export default __webpack_public_path__ + "static/media/browse.7635942b.jpg";